import React, { useRef } from 'react';
import { useState } from 'react'

import { useService } from "@infonova/framework/lib/react/hooks/useService";
import { ServiceConfiguration } from "../../configuration/ServicesConfiguration";
import { usePromise } from "@infonova/framework/lib/react/hooks/usePromise";

import { useContext, useEffect } from "react";
import { ErrorContext } from "@infonova/framework/lib/react/context/error/ErrorContext";
import { reactErrorContext } from "@infonova/framework/lib/react/context/error/reactErrorContext";

import { serviceResolver } from '@infonova/framework/lib/service/configuration/serviceResolver';


import { OrganizationComponent } from '../folder/OrganizationFolder';

import { ExternalServiceConfiguration } from "../../configuration/ExternalServiceConfiguration";



type BaseComponentProps = {
    id: string,
    callback: (evt: any) => void
};

const BaseComponent = (props: BaseComponentProps) => {
    const [customerId, setCustomerId] = useState(null);
    const [assignOrderUrl, setAssignOrderUrl] = useState(null);
    const [draftOrderId, setDraftOrderId] = useState(null);
    const [accountId, setAccountId] = useState(null);
    const [opportunityId, setOpportunityId] = useState(null);
    const [quoteId, setQuoteId] = useState(null);

    const salesforceService = serviceResolver().getService(ExternalServiceConfiguration.SalesforceService);
    const integrationService = serviceResolver().getService(ExternalServiceConfiguration.IntegrationService);


    let addressManagement;

    useEffect(() => {
        salesforceService.addSalesforceMessageHandler((resp: any) => {
            if (resp.name === "accountGetResponse") {
                setAssignOrderUrl(resp.data.assignOrderUrl);
                setDraftOrderId(resp.data.draftOrderId);
                setAccountId(resp.data.accountId);
                setOpportunityId(resp.data.opportunityId);
                setQuoteId(resp.data.quoteId);
                setCustomerId(resp.data.customerAccountId);
            }
        });

        salesforceService.sendSalesforceMessage({ name: "CustomerAccount", value: "GET" });
    }, []);

    window['serviceRegistry'] = serviceResolver();
    try {
        addressManagement = useService(ServiceConfiguration.AddressService);
    } catch (err) {
        console.log("err " + err)
    }
    try {
        addressManagement = useState(() => serviceResolver().getService(ServiceConfiguration.AddressService))[0];
    } catch (err) {
        console.log("err " + err)
    }

    /** Clear error if id has changed */

    const assignOrderId =  async (evt) => {
        let orgSelection = evt.key.toString();
        const billingAccountId = orgSelection.indexOf('/') >= 0 ? orgSelection.substring((orgSelection).lastIndexOf('/') + 1) : evt.key;
        await integrationService.assignDraftOrderId(assignOrderUrl, {
            draftOrderId: draftOrderId,
            billingAccountId: billingAccountId,
            accountId: accountId,
            opportunityId: opportunityId,
            quoteId: quoteId
        });
    }

    const callback = (evt) => {
        assignOrderId(evt);
        props.callback(evt);
    };

    {/* @ts-ignore */ }
    return assignOrderUrl && <div style={{ minHeight: "50rem" }}>
        <OrganizationComponent id={customerId} callback={callback}></OrganizationComponent>
        {/* <div slot="header">Address</div>
        <div>

            <DisplayAddress id={props.id} />

        </div>
        <div slot="footer" className="example">Footer</div> */}
        {/* @ts-ignore */}
    </div>
};

export { BaseComponent };
